<div class="modal-header">
    <h5 class="modal-title w-100 text-center">{{couponId ? 'Edit' :
        'Add'}}&nbsp;Coupon</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal"
        aria-label="Close" (click)="closeModal()">
    </button>
</div>

<div class="col-md-12">

    <div class="border shadow p-3">

        <form [formGroup]="couponForm" (ngSubmit)="onSubmit()">
            <div class="row g-3">

                <div class="col-md-6">
                    <label class="form-label">Offer Name</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Offer Name"
                        formControlName="offer_name" />
                    <div
                        *ngIf="couponForm.get('offer_name')?.touched && couponForm.get('offer_name')?.invalid"
                        class="text-danger small">
                        Name is required
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Coupon Code</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Coupon Code"
                        formControlName="coupon_code" />
                    <div
                        *ngIf="couponForm.get('coupon_code')?.touched && couponForm.get('coupon_code')?.invalid"
                        class="text-danger small">
                        Code is required (max 20 chars)
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Discount (%)</label>
                    <input
                        type="number"
                        class="form-control" min="0" max="100"
                        placeholder="Discount"
                        formControlName="discount" />
                    <div
                        *ngIf="couponForm.get('discount')?.touched && couponForm.get('discount')?.invalid"
                        class="text-danger small">
                        Enter a value 1-100
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Cap Amount</label>
                    <input
                        type="number"
                        class="form-control"
                        placeholder="Cap Amount"
                        formControlName="cap_amount" />
                    <div
                        *ngIf="couponForm.get('cap_amount')?.touched && couponForm.get('cap_amount')?.invalid"
                        class="text-danger small">
                        Must be ≥ 0
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Valid From</label>
                    <input
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        ngbDatepicker
                        #d1="ngbDatepicker"
                        formControlName="valid_from"
                        (click)="d1.toggle()"
                        [minDate]="minDate" />
                    <div *ngIf="couponForm.hasError('dateRange')"
                        class="text-danger small">
                        {{ couponForm.getError('dateRange') }}
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label">Valid To</label>
                    <input
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        ngbDatepicker
                        #d2="ngbDatepicker"
                        formControlName="valid_to"
                        (click)="d2.toggle()"
                        [minDate]="couponForm.get('valid_from')?.value" />
                </div>

                <div class="col-md-12" *ngIf="couponType==='segment'">
                    <label class="form-label">Customer</label>
                    <ng-select
                        [items]="sources"
                        bindLabel="phone_no"
                        bindValue="id"
                        [multiple]="true"
                        placeholder="Select Customers"
                        formControlName="user"
                        [clearable]="false"
                        [ngClass]="{'is-invalid': couponForm.get('discount_source')?.invalid && couponForm.get('discount_source')?.touched}">
                    </ng-select>
                    <div
                        class="invalid-feedback"
                        *ngIf="couponForm.get('discount_source')?.invalid && couponForm.get('discount_source')?.touched ">
                        At least one customer is required.
                    </div>
                </div>

                <div class="col-md-6">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="multiple"
                        formControlName="is_multiple" />
                    <label class="form-check-label" for="multiple">
                        &nbsp;&nbsp; Is Multiple
                    </label>
                </div>

                <div class="col-md-6">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="enabled"
                        formControlName="is_enable" />
                    <label class="form-check-label" for="enabled">
                        &nbsp;&nbsp; Is Enabled
                    </label>
                </div>

                <div class="col-12 text-end">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="couponForm.invalid">
                        Save Coupon
                    </button>
                </div>

            </div>
        </form>

    </div>
</div>